/**
 * Sync Status Hook
 *
 * Subscribe to sync manager status updates.
 * Use this to display sync indicators in UI.
 */

import { useState, useEffect } from 'react';
import { syncManager, SyncStatus } from '../services/syncManager';

/**
 * Hook to get current sync status.
 * Automatically updates when status changes.
 */
export function useSyncStatus(): SyncStatus {
  const [status, setStatus] = useState<SyncStatus>(syncManager.getStatus());

  useEffect(() => {
    // Subscribe to status changes
    const unsubscribe = syncManager.subscribe((newStatus) => {
      setStatus(newStatus);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return status;
}

export default useSyncStatus;
